"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var collection_mapper_1 = require("./collections/collection.mapper");
exports.collectionMapper = collection_mapper_1.collectionMapper;
var collectionEvent_mapper_1 = require("./collections/collectionEvent.mapper");
exports.collectionEventMapper = collectionEvent_mapper_1.collectionEventMapper;
exports.collectionUpdatedEventMapper = collectionEvent_mapper_1.collectionUpdatedEventMapper;
var productToUpdate_mapper_1 = require("./products/productToUpdate.mapper");
exports.productToUpdateMapper = productToUpdate_mapper_1.productToUpdateMapper;
var product_mapper_1 = require("./products/product.mapper");
exports.productMapper = product_mapper_1.productMapper;
exports.productWithVariantsMapper = product_mapper_1.productWithVariantsMapper;
exports.productDbDriverMapper = product_mapper_1.productDbDriverMapper;
var productEvent_mapper_1 = require("./productEvent/productEvent.mapper");
exports.productEventMapper = productEvent_mapper_1.productEventMapper;
exports.productUpdatedEventMapper = productEvent_mapper_1.productUpdatedEventMapper;
var order_mapper_1 = require("./orders/order.mapper");
exports.orderMapperDbDriver = order_mapper_1.orderMapperDbDriver;
exports.orderMapper = order_mapper_1.orderMapper;
exports.createOrderParamsMapper = order_mapper_1.createOrderParamsMapper;
var coupons_mapper_1 = require("./coupons/coupons.mapper");
exports.couponMapper = coupons_mapper_1.couponMapper;
var productOptionsAvailability_mapper_1 = require("./productOptionsAvailability/productOptionsAvailability.mapper");
exports.productOptionsAvailabilityMapper = productOptionsAvailability_mapper_1.productOptionsAvailabilityMapper;
var cart_mapper_1 = require("./carts/cart.mapper");
exports.cartMapper = cart_mapper_1.cartMapper;
var cart_mapper_client_1 = require("./carts/cart.mapper.client");
exports.cartMapperClient = cart_mapper_client_1.cartMapperClient;
var abandonedCart_mapper_1 = require("./abandonedCarts/abandonedCart.mapper");
exports.abandonedCartMapper = abandonedCart_mapper_1.abandonedCartMapper;
var productVariants_mapper_1 = require("./productVariants/productVariants.mapper");
exports.productVariantsMapper = productVariants_mapper_1.productVariantsMapper;
exports.productVariantsUpdatedMapper = productVariants_mapper_1.productVariantsUpdatedMapper;
var inventory_mapper_1 = require("./inventory/inventory.mapper");
exports.inventoryMapper = inventory_mapper_1.inventoryMapper;
exports.inventoryDbDriverMapper = inventory_mapper_1.inventoryDbDriverMapper;
//# sourceMappingURL=index.js.map